import React, { useState, useEffect } from 'react'
import axios from 'axios'

import './BuscaPed.css'

const BuscaPed = () => {
    const [filtro, setFiltro] = useState({ quantidade: 10, filtro: '', tipo: '' })
    const [membros, setMembros] = useState([])
    const [list, setList] = useState([])

    useEffect(() => {
        const url = `/api/userEtica/getMembros`
        axios(url)
            .then(res => {
                setMembros(res.data)
            })
            .then()
            .catch(error => {
                alert(error.response.data)
            })
    }, [])

    useEffect(() => {
        const url = `/api/ped/getPedList`
        axios.post(url, filtro)
            .then(res => {
                setList(res.data)
            })
            .then()
            .catch(error => {
                alert(error.response.data)
            })
    }, [filtro])

    const updateField = (e) => {
        const { name, value } = e.target
        setFiltro(prevState => ({
            ...prevState,
            [name]: value
        }))
    }

    return (
        <React.Fragment>
            <div className="labelBuscaPed">
                <i className="bi bi-search iconeBuscaPed"></i>
                PESQUISAR PED
            </div>
            <div className="filtroDiv">
                <span className='spanFiltroBuscaPed'>Exibir</span>
                <select className='selectFiltroBuscaPed'
                    name="quantidade"
                    onChange={e => updateField(e)} >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="50">50</option>
                </select>
            </div>
            <div className="filtroDiv">
                <span className='spanFiltroBuscaPed'>Filtrar</span>
                <select className='selectFiltroBuscaPed' defaultValue=""
                    name="filtro"
                    onChange={e => updateField(e)} >
                    <option value=""></option>
                    <option value="representante">Representante</option>
                    <option value="representado">Representado</option>
                    <option value="numeroCrefito">Nº Crefito</option>
                    <option value="numeroPaf">Nº PAF/PAD</option>
                    <option value="numeroPed">Nº PED</option>
                </select>
            </div>
            <div className="filtroDiv">
                {RenderFiltro()}
            </div>
            <div className="overFlow">
                <div className="buscaPedHeader">
                    <div className="buscaPedElemntHeader">Representante</div>
                    <div className="buscaPedElemntHeader">Representado</div>
                    <div className="buscaPedElemntHeader">Nº Crefito</div>
                    <div className="buscaPedElemntHeader">Nº PAF/PAD</div>
                    <div className="buscaPedElemntHeader">Nº PED</div>
                </div>
                {Render10()}
            </div>
        </React.Fragment>
    )

    function RenderFiltro() {
        let select = []
        membros.map(x => {
            select.push(
                <option key={x.nome} value={x.nome}>{x.nome}</option>
            )
        })
        if (filtro && filtro.filtro === "representante") {
            return (
                <React.Fragment>
                    <span className='spanFiltroBuscaPed'>Representante</span>
                    <input type="text" name="tipo" className='selectFiltroBuscaPed' onChange={e => updateField(e)} />
                </React.Fragment>
            )
        } else if (filtro && filtro.filtro === "representado") {
            return (
                <React.Fragment>
                    <span className='spanFiltroBuscaPed'>Representado</span>
                    <input type="text" name="tipo" className='selectFiltroBuscaPed' onChange={e => updateField(e)} />
                </React.Fragment>
            )
        } else if (filtro && filtro.filtro === "numeroCrefito") {
            return (
                <React.Fragment>
                    <span className='spanFiltroBuscaPed'>Nº Crefito</span>
                    <input type="text" name="tipo" className='selectFiltroBuscaPed' onChange={e => updateField(e)} />
                </React.Fragment>
            )
        } else if (filtro && filtro.filtro === "numeroPaf") {
            return (
                <React.Fragment>
                    <span className='spanFiltroBuscaPed'>Nº PAF/PAD</span>
                    <input type="text" name="tipo" className='selectFiltroBuscaPed' onChange={e => updateField(e)} />
                </React.Fragment>
            )
        } else if (filtro && filtro.filtro === "numeroPed") {
            return (
                <React.Fragment>
                    <span className='spanFiltroBuscaPed'>Nº PED</span>
                    <input type="text" name="tipo" className='selectFiltroBuscaPed' onChange={e => updateField(e)} />
                </React.Fragment>
            )
        }
    }

    function Render10() {
        if (list.length > 0) {
            let tabela = []
            list.map(ped => {
                tabela.push(
                    <div className="buscaPedBody" key={ped.numeroPed}>
                        <a href={`/etica/documentosPed/${ped._id}`}>
                            <div className="buscaPedElemntBody">{ped.representante}</div>
                            <div className="buscaPedElemntBody">{ped.representado}</div>
                            <div className="buscaPedElemntBody">{ped.numeroCrefito}</div>
                            <div className="buscaPedElemntBody">{ped.numeroPaf}</div>
                            <div className="buscaPedElemntBody">{ped.numeroPed}</div>
                        </a>
                    </div>
                )
            })
            return tabela
        }
    }
}

export default BuscaPed